/**
 * R5Tabs
 * -----------------------------------------------------------
 * Centered chip-pill tab bar (calm-tabs style from R5-M1 mock).
 * Distinct from PageTabs — admin pages keep using PageTabs.
 *
 * Props:
 *   tabs:      [{ key, label, icon? }]
 *   activeKey: string
 *   onChange:  (key) => void
 *   align:     'center' | 'start' | 'end'  (default 'center')
 *   className: extra classes
 */
import React from 'react';

export function R5Tabs({
  tabs = [],
  activeKey,
  onChange,
  align = 'center',
  className = '',
  ...rest
}) {
  const cls = [
    'r5-tabs',
    align === 'start' && 'r5-tabs--start',
    align === 'end' && 'r5-tabs--end',
    className,
  ].filter(Boolean).join(' ');

  return (
    <nav className={cls} role="tablist" aria-label="Sections" {...rest}>
      {tabs.map((tab) => {
        const active = tab.key === activeKey;
        return (
          <button
            key={tab.key}
            type="button"
            role="tab"
            aria-selected={active}
            className={`r5-tabs__tab${active ? ' active' : ''}`}
            onClick={() => onChange && onChange(tab.key)}
          >
            {tab.icon && <span className="icon">{tab.icon}</span>}
            {tab.label}
          </button>
        );
      })}
    </nav>
  );
}

export default R5Tabs;
